import { render, staticRenderFns } from "./supplier-requirement-supplier-reqs-a-view-table.vue?vue&type=template&id=6b918745&"
import script from "./supplier-requirement-supplier-reqs-a-view-table.vue?vue&type=script&lang=js&"
export * from "./supplier-requirement-supplier-reqs-a-view-table.vue?vue&type=script&lang=js&"
import style0 from "./supplier-requirement-supplier-reqs-a-view-table.vue?vue&type=style&index=0&id=6b918745&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b918745')) {
      api.createRecord('6b918745', component.options)
    } else {
      api.reload('6b918745', component.options)
    }
    module.hot.accept("./supplier-requirement-supplier-reqs-a-view-table.vue?vue&type=template&id=6b918745&", function () {
      api.rerender('6b918745', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/fl44/partials/supplier-requirement-supplier-reqs-a-view-table.vue"
export default component.exports